import { render, staticRenderFns } from "./FixSmsStartups.vue?vue&type=template&id=2fa55003&scoped=true"
import script from "./FixSmsStartups.vue?vue&type=script&lang=js"
export * from "./FixSmsStartups.vue?vue&type=script&lang=js"
import style0 from "./FixSmsStartups.vue?vue&type=style&index=0&id=2fa55003&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa55003",
  null
  
)

export default component.exports